import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/interface/store';
import { Request } from '@/interface/store/request';

export const initialState = () => {
  return {
    dataList: [],
    statusCount: [],
    queryParams: {
      id: '',
      type: 'request',
      attributes: '',
      limit: 20,
      offset: 0,
      order: '-statusChangedAt',
      include: '',
      status: 'PENDING',
      hasDropdown: false,
      fkGroupId: '',
      fkUserId: '',
    },
    requestData: {
      id: '',
      name: '',
      quantity: 0,
      quantityReceived: 0,
      catalogNumber: '',
      url: null,
      rawUrl: null,
      vendorName: '',
      manufacturerName: '',
      price: 0,
      notes: null,
      details: null,
      source: null,
      requestedAgainst: null,
      shipping: null,
      unitSize: null,
      timeFrame: null,
      isUrgent: false,
      requiredBefore: null,
      requisitionNumber: null,
      confirmationNumber: null,
      invoiceNumber: null,
      trackingNumber: null,
      boughtFrom: null,
      expectedOn: null,
      statusChangedAt: '',
      fkGroupId: '',
      fkProductId: null,
      fkVendorId: '',
      fkManufacturerId: '',
      fkTypeId: '',
      fkGrantId: null,
      status: '',
      requestedBy: '',
      fkPurchaseOrderId: null,
      fkOrderRequestHistories: [],
      fkOrderRequestComments: [],
      fkOrderRequestAttachments: [],
      fkType: {
        id: '',
        name: '',
        fkGroupId: '',
        prefix: '',
      },
      fkGrant: {
        id: '',
        name: '',
        isDisabled: false,
      },
      fkVendor: {
        id: '',
        name: '',
        url: null,
        contactName: null,
        contactPhone: null,
        contactEmail: null,
        info: null,
        fkGroupId: '',
      },
      fkManufacturer: {
        id: '',
        name: '',
        url: null,
        contactName: null,
        contactPhone: null,
        contactEmail: null,
        info: null,
        fkGroupId: '',
      },
      fkRequestedBy: {
        id: '',
        organization: null,
        email: '',
        firstName: null,
        lastName: null,
        fullName: '',
        position: null,
        phoneNumber: '',
        isEmailConfirmed: false,
        subscribedToNewsletters: false,
        emailSettings: {
          orderRequestUpdated: '',
          orderRequestAccepted: '',
        },
        settings: {
          recordsPerPage: 0,
          ordersBackupInterval: '',
          inventoryBackupInterval: '',
          receiveCommentNotifications: false,
        },
        lastGroupId: null,
      },
      fkPurchaseOrder: {
        id: '',
        name: '',
        shipping: {
          amount: 0,
          currency: '',
        },
        tax: {
          amount: 0,
          currency: '',
        },
        total: {
          amount: 0,
          currency: '',
        },
        notes: null,
        fkGroupId: '',
      },
    },
    totalCount: 0,
    poList: [],
    poListTotalCount: 0,
    requestAttachments: [],
    requestComments: [],
    requestHistories: [],
    requestFilter: {
      Types: { subArray: [] },
      Users: { subArray: [] },
      Vendors: { subArray: [] },
      Manufacturers: { subArray: [] },
      Grants: { subArray: [] },
    },
    requestFilterStack: {
      Vendors: [],
      Manufacturers: [],
      Types: [],
      Users: [],
      Grants: [],
    },
    isDrawerOpen: false,
    isTooltipShown: false,
  };
};

export const state: Request = initialState();

const namespaced: boolean = true;

export const request: Module<Request, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
